var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgCarrot = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 8L11 21C11 21 11.5 22 12 22C12.5 22 13 21 13 21L12 8Z",
    fill: "#E65100"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 8L10.5 20C10.5 20 11.2 21.5 12 21.5C12.8 21.5 13.5 20 13.5 20L12 8Z",
    fill: "#F57C00"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 13.5L13.5 12",
    stroke: "#E65100",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11 16L13 15",
    stroke: "#E65100",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11 18.5L13 17.5",
    stroke: "#E65100",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M12 8C12 8 10 4 8 3",
    stroke: "#388E3C",
    strokeWidth: 1.3,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M12 8C12 8 12 3 12 2",
    stroke: "#388E3C",
    strokeWidth: 1.3,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M12 8C12 8 14 4 16 3",
    stroke: "#388E3C",
    strokeWidth: 1.3,
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M8 3C7 2.5 6 3 6 3",
    stroke: "#4CAF50",
    strokeWidth: 1,
    strokeLinecap: "round"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M16 3C17 2.5 18 3 18 3",
    stroke: "#4CAF50",
    strokeWidth: 1,
    strokeLinecap: "round"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCarrot);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/carrot.920800716951f536b3f7f609f56b5010.svg";